module.exports = __webpack_public_path__ + "audio/fiveAudio.adb3de1b.mp3";